// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-content {
  font-family: monospace;
  line-height: 1.6;
  color: #e8e8e6;
  padding: 20px;
}

.markdown-content h1, .markdown-content h2, .markdown-content h3 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 1.25;
  color: #fff;
}

.markdown-content h1 {
  font-size: 2em;
  border-bottom: 1px solid #3e3f40;
  padding-bottom: .3em;
}

.markdown-content h2 {
  font-size: 1.5em;
  border-bottom: 1px solid #3e3f40;
  padding-bottom: .3em;
}

.markdown-content p {
  margin-bottom: 16px;
}

.markdown-content code {
  background-color: #202222;
  border-radius: 3px;
  font-size: 85%;
  margin: 0;
  padding: .2em .4em;
  color: #61dafb;
}

.markdown-content pre {
  background-color: #202222;
  border-radius: 3px;
  font-size: 85%;
  line-height: 1.45;
  overflow: auto;
  padding: 16px;
  margin-bottom: 16px;
}

.markdown-content pre code {
  background-color: transparent;
  padding: 0;
}

.markdown-content blockquote {
  border-left: .25em solid #3e3f40;
  color: #8d9191;
  padding: 0 1em;
  margin-bottom: 16px;
}

.markdown-content ul, .markdown-content ol {
  padding-left: 2em;
  margin-bottom: 16px;
}

.markdown-content li {
  margin-bottom: 8px;
}

.markdown-content img {
  max-width: 100%;
  box-sizing: content-box;
  background-color: #202222;
  border-radius: 3px;
}

.markdown-content hr {
  height: 1px;
  background-color: #3e3f40;
  border: none;
  margin: 24px 0;
}

.markdown-content a {
  color: #61dafb;
  text-decoration: none;
}

.markdown-content a:hover {
  text-decoration: underline;
}

.markdown-content table {
  border-collapse: collapse;
  margin-bottom: 16px;
  width: 100%;
}

.markdown-content th, .markdown-content td {
  border: 1px solid #3e3f40;
  padding: 6px 13px;
}

.markdown-content th {
  background-color: #202222;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/router/MarkdownStyles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".markdown-content {\n  font-family: monospace;\n  line-height: 1.6;\n  color: #e8e8e6;\n  padding: 20px;\n}\n\n.markdown-content h1, .markdown-content h2, .markdown-content h3 {\n  margin-top: 24px;\n  margin-bottom: 16px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #fff;\n}\n\n.markdown-content h1 {\n  font-size: 2em;\n  border-bottom: 1px solid #3e3f40;\n  padding-bottom: .3em;\n}\n\n.markdown-content h2 {\n  font-size: 1.5em;\n  border-bottom: 1px solid #3e3f40;\n  padding-bottom: .3em;\n}\n\n.markdown-content p {\n  margin-bottom: 16px;\n}\n\n.markdown-content code {\n  background-color: #202222;\n  border-radius: 3px;\n  font-size: 85%;\n  margin: 0;\n  padding: .2em .4em;\n  color: #61dafb;\n}\n\n.markdown-content pre {\n  background-color: #202222;\n  border-radius: 3px;\n  font-size: 85%;\n  line-height: 1.45;\n  overflow: auto;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.markdown-content pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n.markdown-content blockquote {\n  border-left: .25em solid #3e3f40;\n  color: #8d9191;\n  padding: 0 1em;\n  margin-bottom: 16px;\n}\n\n.markdown-content ul, .markdown-content ol {\n  padding-left: 2em;\n  margin-bottom: 16px;\n}\n\n.markdown-content li {\n  margin-bottom: 8px;\n}\n\n.markdown-content img {\n  max-width: 100%;\n  box-sizing: content-box;\n  background-color: #202222;\n  border-radius: 3px;\n}\n\n.markdown-content hr {\n  height: 1px;\n  background-color: #3e3f40;\n  border: none;\n  margin: 24px 0;\n}\n\n.markdown-content a {\n  color: #61dafb;\n  text-decoration: none;\n}\n\n.markdown-content a:hover {\n  text-decoration: underline;\n}\n\n.markdown-content table {\n  border-collapse: collapse;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.markdown-content th, .markdown-content td {\n  border: 1px solid #3e3f40;\n  padding: 6px 13px;\n}\n\n.markdown-content th {\n  background-color: #202222;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
